import { Link } from 'react-router-dom';
import { Sun, Mail, Phone, MapPin, Heart, MessageCircle } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1E293B] text-white py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-6" data-testid="footer-logo">
              <div className="w-10 h-10 bg-[#FACC15] rounded-full flex items-center justify-center">
                <Sun className="w-6 h-6 text-[#422006]" />
              </div>
              <span className="text-2xl font-bold font-['Fredoka']">Protopia</span>
            </Link>
            <p className="text-[#94A3B8] leading-relaxed">
              Empowering children in Kenya through joy, mentorship, and community. Every child deserves to dream big.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-['Fredoka']">Quick Links</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-home">Home</Link>
              <Link to="/about" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-about">About Us</Link>
              <Link to="/events" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-events">Fun in the Sun</Link>
              <Link to="/gallery" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-gallery">Gallery</Link>
            </nav>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-['Fredoka']">Get Involved</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/donate" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-donate">Donate</Link>
              <Link to="/volunteer" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-volunteer">Volunteer</Link>
              <Link to="/contact" className="text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-contact">Contact Us</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-['Fredoka']">Contact</h4>
            <div className="flex flex-col gap-4">
              <a href="mailto:protopiatukunn@gmail.com" className="flex items-center gap-3 text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-email">
                <Mail className="w-5 h-5" />
                <span>protopiatukunn@gmail.com</span>
              </a>
              <a href="tel:+15126997392" className="flex items-center gap-3 text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-phone">
                <Phone className="w-5 h-5" />
                <span>512-699-7392</span>
              </a>
              <a href="https://wa.me/17373860709" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-[#94A3B8] hover:text-white transition-colors" data-testid="footer-whatsapp">
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp: +1 737-386-0709</span>
              </a>
              <div className="flex items-center gap-3 text-[#94A3B8]">
                <MapPin className="w-5 h-5" />
                <span>Nairobi, Kenya</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-[#334155] flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#94A3B8] text-sm">
            © {new Date().getFullYear()} Protopia Wellness Community. All rights reserved.
          </p>
          <p className="text-[#94A3B8] text-sm flex items-center gap-2">
            Made with <Heart className="w-4 h-4 text-[#FF7A59]" /> for the children of Kenya
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
